var map = {
	"./pp-en": "TWbx",
	"./pp-en.js": "TWbx",
	"./pp-ja": "xfga",
	"./pp-ja.js": "xfga",
	"./tos-en": "m3EI",
	"./tos-en.js": "m3EI",
	"./tos-ja": "kqTV",
	"./tos-ja.js": "kqTV"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "hA6K";
module.exports = webpackAsyncContext;